import { getReferrerIsRover, getReferrerIsSeoLanding } from './referrerLogic';

function safeParseUrl(maybeUrl: string): URL | null {
  try {
    return new URL(maybeUrl);
  } catch (_) {
    return null;
  }
}

export function getReferrer(): URL | null {
  return safeParseUrl(document.referrer) ?? null;
}

export function referrerIsRover(url = getReferrer()): boolean {
  return getReferrerIsRover(url);
}

export function referrerIsSeoLanding(url = getReferrer()): boolean {
  return getReferrerIsSeoLanding(url);
}
